import { render, staticRenderFns } from "./Proclamation.vue?vue&type=template&id=3847893e&"
import script from "./Proclamation.vue?vue&type=script&lang=js&"
export * from "./Proclamation.vue?vue&type=script&lang=js&"
import style0 from "./Proclamation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports